

export default {
  
  components: {
    NewBeneficiaryForm: () => import(/* webpackChunkName: "beneficiaries" */ './NewBeneficiaryForm.vue'),
  },
  
  data: () => ({
    beneficiary: {
      rib: null
    }
  }),
  
  computed: {
    
    title () {
      return (this.isExistingBeneficiary) ? this.$t('beneficiary.edit.title') : this.$t('beneficiary.new.title')
    },
    
    isExistingBeneficiary () {
      return !!this.$route.params.beneficiaryId
    },

    isExistingBeneficiaryList () {
      return !!this.$route.params.listId
    },

    getBeneficiaryListPath () {
      if (this.isExistingBeneficiaryList) {
        return '/transfers/beneficiaries-list/' + this.$route.params.listId
      } else {
        return '/transfers/beneficiary-lists'
      }
    },
    
    address () {
      return null
    }
  },
  
  mounted () {
    if (false) {
      this.$router.push('/transfers/beneficiary-lists')
    }
    // TODO CHECK IF LIST ID AND BENEFICIARY ID CORRECT
    this.$bus.$on('local-file-added', this.onRibAttached)
  },
  
  destroyed () {
    this.$bus.$off('local-file-added', this.onRibAttached)
  },
  
  methods: {
    
    addRib () {
      this.showModal({
        childVue: 'join-document',
        wrapperClass: 'modal modal--md',
        dataModel: {
          isLocal: true,
          multipleFiles: false
        },
        autoQueue: false
      })
    },

    onRibAttached (file) {
      this.beneficiary.rib = file
    },

    removeRib () {
      this.beneficiary.rib = null
    }
  }
}
